// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"eef75670","123":"0f92f4ed","288":"a10f9253","353":"a870e358","377":"6a2cbae2"}[chunkId] + ".chunk.js";
};